
















































































































































































































import Vue from 'vue';
// eslint-disable-next-line no-unused-vars
import { IRootRoutes, rootRoutes } from '@/router';
import ConnectWalletButton from './ConnectWalletButton.vue';
import IconSettings from './Icons/IconSettings.vue';
import IconMoreHorz from './Icons/IconMoreHorz.vue';
import AboutMenu from './AboutMenu.vue';
import SettingsModal from './SettingsModal.vue';

export interface IHeaderData {
  rootRoutes: IRootRoutes;
  showSettings: Boolean;
  showAboutMenu: Boolean;
}

export default Vue.extend({
  name: 'Header',
  components: {
    ConnectWalletButton,
    IconSettings,
    IconMoreHorz,
    SettingsModal,
    AboutMenu,
  },
  data: (): IHeaderData => ({
    rootRoutes,
    showSettings: false,
    showAboutMenu: false,
  }),
  methods: {
    clickOnSettings() {
      this.showAboutMenu = false;
      this.showSettings = true;
    },
    clickOnAboutMenu() {
      this.showSettings = false;
      this.showAboutMenu = !this.showAboutMenu;
    },
  },
});
